import React, { Component } from "react";
import { connect } from "react-redux";
import RsPolyline from "./RouteSuggestion/RsPolyline";
import TruckMarker from "./RouteSuggestion/TruckMarker";
import DropMarker from "./RouteSuggestion/DropMarker"
import RsWaypoints from "./RouteSuggestion/RsWaypoints"

import { Circle, Polygon, Polyline } from "@vis.gl/react-google-maps";
import ClusterMarker from "./RouteSuggestion/ClusterMarker";
import { groupDropPoints, fanPlan } from "./RouteSuggestion/spiderfy";

import { 
SET_MAP_LOADING,

} from "../../reducers/map";


import RsHazardMarker from "./RouteSuggestion/RsHazardMarker";

class RouteSuggestMap extends Component {
    componentWillUpdate(nextProps, nextState) {
        // if (nextState.open == true && this.state.open == false) {
            this.props.SET_MAP_LOADING(true)
        // }
      }

    // componentDidUpdate(prevProps, prevState) {
    //     // if (prevProps.data !== this.props.data) {
    //     //     console.log("KAI map updated")
    //         this.props.SET_MAP_LOADING(false)
    //     // }
        
    // }

  renderDrop = (point, index, position) => (
    <DropMarker
      {...point}
      key={`droppoint-${index}`}
      id={index}
      isFirst={false}
      isLast={false}
      defaultDraggable={this.props.map_loading ? false : true}
      position={position}
      isGroup={point.isGroup}
      description={point.description}
    />
  );

  // Returns fanned {lat,lng} positions for a group's members, in member order.
  fannedPositions = (group) => {
    const zoom = this.props.map ? this.props.map.getZoom() : 15;
    const plan = fanPlan(group.members.length, group.center.lat, zoom);
    const centerLatLng = new window.google.maps.LatLng(group.center.lat, group.center.lng);
    return plan.map((p) => {
      const offset = window.google.maps.geometry.spherical.computeOffset(
        centerLatLng,
        p.dist,
        p.heading
      );
      return { lat: offset.lat(), lng: offset.lng() };
    });
  };

    render() {

  
      return (
          // https://developers.google.com/maps/documentation/javascript/reference/polyline#PolylineOptions
          // visible
          // defaultVisible
  
          <React.Fragment>
              {this.props.suggestion_routes.hasOwnProperty("routes") && <RsWaypoints/>}
              

              {this.props.show_master_or_candidate !==2 && 
              this.props.suggestionPolylineList && 
              this.props.suggestionPolylineList.length>0 && 
              this.props.suggestionPolylineList.map((polyline, index) => {
                  return (
                      <RsPolyline
                      {...polyline}
                      key={`polyline-${index}`}
                      id={polyline.id}
                      path={polyline.path}
                      editable={polyline.editable}
                    //   info={polyline.info}
                      />
                  );
              })}

 
            {this.props.markerList.length>0 && this.props.markerList.map((marker, index) => {
                return (
                    <RsHazardMarker
                        {...marker}
                        key={`marker-${marker.id}`}
                        id={marker.id}
                        position={marker.position}
                        info={marker.info}
                        editable={marker.editable}
                        isGroup={marker.isGroup}
                        category={marker.category}
                        />
                );
            })}
            {this.props.truck_location && 
                 (
                    <TruckMarker
                        key="truck_id"
                        id="truck_id"
                        name={this.props.truck_location.name}
                        position={this.props.truck_location.position}
                        />
            )}
            {this.props.circleList && this.props.circleList.length>0 && this.props.circleList.map((circle, index) => {
                return (
                    <Circle
                    key={`circle-${circle.id}`}
                    id={circle.id}
                    center={circle.center}
                    color="blue"
                    radius={circle.radius}
                    {...{
                        zIndex: 10,
                        strokeColor: 'red',
                        fillColor: 'red',
                        strokeOpacity: 1,
                        strokeWeight: 2,
                        fillOpacity: 0.3
                    }}
                    />
                );
            })}
            {this.props.polygonList && this.props.polygonList.length>0 && this.props.polygonList.map((polygon, index) => {
                return (
                    <Polygon
                    {...{
                        zIndex: 10,
                        strokeColor: 'red',
                        fillColor: 'red',
                        strokeOpacity: 1,
                        strokeWeight: 2,
                        fillOpacity: 0.3
                    }}
                    key={`polygon-${polygon.id}`}
                    id={polygon.id}
                    paths={polygon.path}
                    />
                );
            })}


            {groupDropPoints(this.props.dropPointList).map((group) => {
              if (group.members.length === 1) {
                const { point, index } = group.members[0];
                return this.renderDrop(point, index, point.position);
              }

              if (this.props.spiderfyKey !== group.key) {
                return (
                  <ClusterMarker
                    key={`cluster-${group.key}`}
                    groupKey={group.key}
                    center={group.center}
                    count={group.members.length}
                  />
                );
              }

              const positions = this.fannedPositions(group);
              return group.members.map(({ point, index }, i) => (
                <React.Fragment key={`fan-${group.key}-${index}`}>
                  <Polyline
                    path={[group.center, positions[i]]}
                    strokeColor="#7e57c2"
                    strokeOpacity={0.9}
                    strokeWeight={2}
                  />
                  {this.renderDrop(point, index, positions[i])}
                </React.Fragment>
              ));
            })}



              
              {/* <div>
                  <Marker
                      position={this.props.marker_origin}
                      icon={{
                          url: "https://www.google.com/mapfiles/dd-start.png",
                          labelOrigin: new window.google.maps.Point(19, 14),
                          scaledSize: new window.google.maps.Size(22, 36),
                          size: new window.google.maps.Size(22, 36)
                      }}
                  />
                  <Marker
                      position={this.props.marker_desc}
                      icon={{ 
                          url: "https://www.google.com/mapfiles/dd-end.png",
                          labelOrigin: new window.google.maps.Point(19, 14),
                          scaledSize: new window.google.maps.Size(22, 36),
                          size: new window.google.maps.Size(22, 36)
                      }}
                  />
              </div> */}
          </React.Fragment>
      )
    }
  }
const mapStateToProps = function(state) {
    return {
        markerGroup: state.map.markerGroup,
        markerList: state.map.markerList,
        dropPointList: state.map.dropPointList,
        circleList: state.map.circleList,
        polygonList: state.map.polygonList,
        suggestionPolylineList: state.map.suggestionPolylineList,
        truck_location : state.map.truck_location,
        suggestion_routes: state.map.suggestion_routes,
        spiderfyKey: state.map.spiderfyKey,
        map_loading: state.map.map_loading,
    };
  };
  
  const mapActionsToProps = {
    SET_MAP_LOADING,
  };
  
  export default connect(
    mapStateToProps,
    mapActionsToProps
  )(RouteSuggestMap);
  
